import type { StorageInstance } from 'storage/domain/Storage'
import type { MasterData } from 'types/masterData'

import {
	ACCOUNT_ID_KEY,
	EMAIL_KEY,
	EXTERNAL_ID_KEY,
	HASHED_EMAIL_KEY,
	LOGGED_KEY,
	LOYALTY_PROGRAM_KEY,
	NAME_KEY,
	SURNAME_KEY,
	TOKEN_KEY,
} from '../../constants'
import type { AuthOrchestratorData } from '../../types/auth'
import type { Session } from '../../types/session'
import { sessionCache } from '../sessionCache'
import { setLegacyToken } from '../setLegacyToken'

export const setSessionCacheStorage = async (
	sessionData: AuthOrchestratorData | Session,
	masterData: MasterData
): Promise<void> => {
	try {
		const {
			logged,
			token,
			externalId,
			email,
			hashedEmail,
			name,
			surname,
			accountId,
			loyaltyProgram,
		} = sessionData

		const sessionStorage: StorageInstance = sessionCache(masterData)

		await Promise.all([
			sessionStorage.addKeyToCache(EMAIL_KEY, email ?? null),
			sessionStorage.addKeyToCache(HASHED_EMAIL_KEY, hashedEmail ?? null),
			sessionStorage.addKeyToCache(NAME_KEY, name ?? null),
			sessionStorage.addKeyToCache(SURNAME_KEY, surname ?? null),
			sessionStorage.addKeyToCache(EXTERNAL_ID_KEY, externalId ?? null),
			sessionStorage.addKeyToCache(TOKEN_KEY, token),
			sessionStorage.addKeyToCache(LOGGED_KEY, logged),
			sessionStorage.addKeyToCache(ACCOUNT_ID_KEY, accountId ?? null),
			sessionStorage.addKeyToCache(LOYALTY_PROGRAM_KEY, loyaltyProgram ?? null),
		])

		if (token) {
			// TODO: Legacy token for dataManager on micros
			setLegacyToken(token)
		}
	} catch {
		throw new Error('[Session] Error to store session data on IndexedDb')
	}
}
